export default "__VITE_ASSET__bN$sJ_za__"